import { TableSearchAndFilters } from "ui/data-grid";
import InboxAllFilters from "containers/admin/inbox/components/inbox-all-filters/inbox-all-filters";
import ColumnOptions from "components/partials/column-options/column-options";

import {
  DEFAULT_INBOX_FILTERS_TO_APPLY,
  INBOX_FILTER_ID_TO_TITLE,
  INBOX_FILTER_VALUE_TO_LABEL,
} from "containers/admin/inbox/inbox.consts";
import { ColumnOption } from "types/table";

import { UserTableLayout } from "hooks/api/use-user-layout";

import { FiltersToApplyOnInbox } from "containers/admin/inbox/inbox.types";

interface InboxHeaderProps {
  setCurrentSearchTerm: (searchTerm: string) => void;
  isLoading: boolean;
  filtersToApply: FiltersToApplyOnInbox;
  setFiltersToApply: (next: FiltersToApplyOnInbox) => void;
  tableColumnsConfig: UserTableLayout;
  columnOptions: Array<ColumnOption>;
  onToggleColumn: (columnId: string) => void;
}

const InboxHeader = ({
  setCurrentSearchTerm,
  isLoading,
  filtersToApply,
  setFiltersToApply,
  tableColumnsConfig,
  columnOptions,
  onToggleColumn,
}: InboxHeaderProps) => {
  return (
    <TableSearchAndFilters
      setCurrentSearchTerm={setCurrentSearchTerm}
      filtersToApply={filtersToApply}
      setFiltersToApply={setFiltersToApply}
      defaultFiltersToApply={DEFAULT_INBOX_FILTERS_TO_APPLY}
      filterIdToTitle={INBOX_FILTER_ID_TO_TITLE}
      filterValueToLabel={INBOX_FILTER_VALUE_TO_LABEL}
      tableFilters={
        <>
          <InboxAllFilters
            isLoading={isLoading}
            filtersToApply={filtersToApply}
            setFiltersToApply={setFiltersToApply}
          />
          <ColumnOptions
            tableConfigKey="recentCreatives"
            tableColumnsConfig={tableColumnsConfig}
            columnOptions={columnOptions}
            onToggleColumn={onToggleColumn}
          />
        </>
      }
    />
  );
};

export default InboxHeader;
